export default "__VITE_ASSET__Ox3$pEi5__"